import React from "react";
import HeaderMain from "../HeaderMain/HeaderMain";
import Navbar from "../Navbar/Navbar";

const Header = () => {
  return (
    <>
      <Navbar />
      <HeaderMain />
    </>
  );
};

export default Header;
